import React, { useRef, useEffect } from 'react';
// import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import SVG from 'react-inlinesvg';
import {
  MailOutlined,
  CheckOutlined,
  LoginOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons';
import { analytics } from '../modules/analytics';

const ForgotPassword = ({
  session,
  forgotPassword,
}) => {
  const formRef = useRef(null);

  useEffect(() => { analytics.trackView('/forgot-password'), []});

  const prevSession = usePrevious(session);
  useEffect(() => {
    if (typeof prevSession !== 'undefined' && typeof session !== 'undefined') {
      if (prevSession.status === 'running' && session.status === 'idle') {
        injectServerErrors(session.forgotFormErrors);
      }
    }
  }, [session]);
  const injectServerErrors = (formErrors) => {
    formErrors.forEach((formError) => {
      const { message, field } = formError;
      formRef.current.setFields([
        { name: field, errors: [message] },
      ]);
    });
  };

  const onFinish = (values) => {
    forgotPassword(values);
  };

  const { status } = session;
  const isBusy = status === "running";
  const isSuccessful = ('forgotFormSuccess' in session) && session.forgotFormSuccess;

  if (isSuccessful) {
    return (
      <div className="auth__form_wrapper">
        <div className="auth__form_content">
          <div className="text-center mb-3">
            <SVG src={require(`assets/media/auth/check-mail.svg`)} />
          </div>
          <h3>Check Your Inbox</h3>
          <div className="text mb-4 text-justify">
            It's easy &amp; you know the drill.
            Expect an email from us shortly with a password reset link.
            Didn't receive the mail? Check your spam folder just in case.
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <Link to="/login">
            <div className="d-flex align-items-center">Go to Login <ArrowRightOutlined className="ml-2" /></div>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth__form_wrapper">
      <div className="auth__form_content">
        <h3>Forgot Password?</h3>
        <div className="text-secondary mb-4 text-center">
          No worries. Enter your email to receive a password reset link.
        </div>

        <Form onFinish={onFinish} className="auth-form" ref={formRef}>

          <Form.Item name="email" rules={[
            { required: true, message: 'Email cannot be blank.' },
            { type: 'email', message: 'Enter a valid email address.' },
          ]}>
            <Input prefix={<MailOutlined />} placeholder="Email" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary" size="large" icon={<LoginOutlined />}
              loading={isBusy} htmlType="submit" block
            >
              Submit
            </Button>
          </Form.Item>

        </Form>

      </div>

      <div className="text-left">
        <Link to="/login">
          <div className="d-flex align-items-center"><ArrowLeftOutlined className="mr-2" />Back to Login</div>
        </Link>
      </div>
    </div>
  );
};

export { ForgotPassword };


//
// export class ForgotPassword extends React.Component {
//
//   constructor(props) {
//     super(props);
//     this.formRef = React.createRef();
//   }
//
//   static propTypes = {
//     session: PropTypes.shape({
//       isAuthenticated: PropTypes.bool.isRequired,
//       status: PropTypes.string.isRequired,
//       forgotFormErrors: PropTypes.array,
//     }).isRequired,
//     forgotPassword: PropTypes.func.isRequired,
//   };
//
//   componentDidMount() {
//     analytics.trackView('/forgotpassword');
//   }
//
//   componentDidUpdate(prevProps) {
//     if (prevProps.session.status === 'running' && this.props.session.status === 'idle') {
//       this.injectServerErrors(this.props.session.forgotFormErrors);
//     }
//   }
//
//   injectServerErrors = (formErrors) => {
//     formErrors.forEach((formError) => {
//       const { message, field } = formError;
//       this.formRef.current.setFields([
//         {
//           name: field,
//           errors: [message],
//         },
//       ]);
//     });
//   };
//
//   onFinish = (values) => {
//     // eventGA({ category: 'authentication', action: 'forgot-password' });
//     this.props.forgotPassword(values);
//   };
//
//   render() {
//     const { session } = this.props;
//     const { status } = session;
//     const isBusy = status === "running";
//     const isSuccessful = ('forgotFormSuccess' in session) && session.forgotFormSuccess;
//
//     const formView = (
//       <div className="auth__form_wrapper">
//         <div className="auth__form_content">
//           <h3>Forgot Password?</h3>
//           <div className="text-secondary mb-4 text-center">
//             No worries. Enter your email to receive a password reset link.
//           </div>
//
//           <Form onFinish={this.onFinish} className="auth-form" ref={this.formRef}>
//
//             <Form.Item name="email" rules={[
//               { required: true, message: 'Email cannot be blank.' },
//               { type: 'email', message: 'Enter a valid email address.' },
//             ]}>
//               <Input prefix={<MailOutlined />} placeholder="Email" />
//             </Form.Item>
//
//             <Form.Item>
//               <Button
//                 type="primary" size="large" icon={<LoginOutlined />}
//                 loading={isBusy} htmlType="submit" block
//               >
//                 Submit
//               </Button>
//             </Form.Item>
//
//           </Form>
//
//         </div>
//
//         <div className="text-left">
//           <Link to="/login">
//             <div className="d-flex align-items-center"><ArrowLeftOutlined className="mr-2" />Back to Login</div>
//           </Link>
//         </div>
//       </div>
//     );
//
//     const successView = (
//       <div className="auth__form_wrapper">
//         <div className="auth__form_content">
//           <div className="text-center mb-3">
//             <SVG src={require(`assets/media/auth/check-mail.svg`)} />
//           </div>
//           <h3>Check Your Inbox</h3>
//           <div className="text mb-4 text-justify">
//             It's easy &amp; you know the drill.
//             Expect an email from us shortly with a password reset link.
//             Didn't receive the mail? Check your spam folder just in case.
//           </div>
//         </div>
//
//         <div className="d-flex justify-content-end">
//           <Link to="/login">
//             <div className="d-flex align-items-center">Go to Login <ArrowRightOutlined className="ml-2" /></div>
//           </Link>
//         </div>
//       </div>
//     );
//
//     return isSuccessful ? successView : formView;
//   }
// }



// WEBPACK FOOTER //
// ./scripts/presentation/ForgotPassword.jsx